<template>
  <div>
    <back-header :head-title="title">
      <div slot="askTitle" class="ask_title" @click="goAns">提问</div>
    </back-header>
    <div class="wrapper">
      <div class="q_list" v-show="!showContent">
        <ul>
          <li v-for="item in questionData" :key="item.id" @click="goDetail(item.topicId)">
            <div class="q_title">
              <div class="q_left">{{item.question}}</div>
              <!-- <div
                v-show="item.auditStatus == 1"
                class="edit"
                @click="edit(item.question,item.id)"
              >编辑</div> -->
            </div>
            <div class="repeat_part" v-if="item.ansSolutionVoList">
              <div class="repeat_name">
                【评论员】
                <span>{{item.ansSolutionVoList[0].operatorName}}</span>
              </div>
              <div class="repeat_content">{{item.ansSolutionVoList[0].answer}}</div>
            </div>
            <div class="check_status">
              <div
                class="status"
                :class="[{'ever':item.auditStatus == 0},{'green':item.auditStatus == 2},{'red':item.auditStatus == 1}]"
              >{{item.auditStatus | filterStatus}}</div>
              <div class="time">{{item.createDate | filterTime}}</div>
            </div>
          </li>
        </ul>
         <div class="load_more" @click="loadMore('more')">点击加载更多</div>
      </div>
      <div v-show="showContent" class="no_data">
        <div class="img_part">
          <img src="~assets/images/index/empty_state.png" alt />
          <div class="text">提问栏空空如也，期待你的精彩提问哟~</div>
          <div class="ask_btn_no" @click="goAsk()">提问</div>
        </div>

        <div class="choice_part" style="display: none">
          <div class="title">精选问题</div>
          <question-party :chioceQuestionData="choiceData"></question-party>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import backHeader from "components/header/backHeader";
import { getStore } from "assets/commonjs/storage";
import questionParty from "components/questionParty";
import { mapState, mapActions } from "vuex";
import Utils from "assets/commonjs/tool";
import { toast } from "assets/commonjs/toast";
export default {
  data() {
    return {
      title: "我的提问",
      questionData: [],
      showContent: false,
      account: "",
      pageNum: 0,
      pageSize:10
    };
  },
  computed: {
    ...mapState(["choiceData"])
  },
  components: {
    backHeader,
    questionParty
  },
  mounted() {
    let userInfo = JSON.parse(getStore("userInfoAll"));
    if (userInfo === null || userInfo === "") {
      this.$router.push("/login");
    } else {
      this.account = userInfo.account;
    }
    this.init();
  },
  filters: {
    filterStatus(val) {
      if (val == 0) {
        return "待回复";
      } else if (val == 1) {
        return "审核失败";
      } else if (val == 2) {
        return "已回复";
      }
    },

    filterTime(val) {
      if (!val) return "";
      let timeStamp = Utils.getDateTimeStamp(val);

      return Utils.getDateDiff(timeStamp);
    }
  },
  methods: {
    ...mapActions(["getStrageData"]),
    init() {
      this.getMyQuestion();
    },
    goAns(){
      this.$router.push('/questionAnswer')
    },
    getMyQuestion(type) {
      let data = {
        companyId: 1,
        account: this.account,
        pageSize: this.pageSize,
        pageNum: this.pageNum
      };
      this.$api.strageList.getMyQuestion(data).then(res => {
        // console.log(res)
        if (res.data && res.data.code == 0) {
          if (res.data.result.myQuestion.length == 0) {
            if (type == "more") {
              toast("没有更多数据了");
            }else{
               this.getStrageData();
              this.showContent = true;
            }
          }else{
            this.showContent = false;
            if(type == "more"){
              this.questionData =this.questionData.concat(res.data.result.myQuestion);
          
            }else{     
             this.questionData = res.data.result.myQuestion;
            }
           
          }
         
        }
      });
    },
    goAsk() {
      this.$router.push("/questionAnswer");
    },
    goDetail(id){
      this.$router.push({ path: 'questionDetail',query:{id:id} });
    },
     loadMore(type) {
      this.pageNum += this.pageSize;
      this.getMyQuestion(type);
    }
    // edit(message, id) {
    //   this.$router.push(`/ask/:${id}`)
      
    // }
  }
};
</script>

<style lang="scss" scoped>
@import "~assets/styles/mixin";
.load_more {
  @include sc(0.3rem, #333);
  text-align: center;
  margin-top: 0.3rem;
}
.wrapper {
  // padding: 0 0.3rem;
}
.q_list {
  padding-bottom: .3rem;
  ul {
    li {
      padding: 0 0 0.4rem;
      border-bottom: 0.025rem solid #ddd;
      margin: 0.4rem .3rem 0;
      .q_title {
        display: flex;
        justify-content: space-between;
            align-items: baseline;
        .q_left {
          @include sc(0.28rem, #333);
          width: 5.5rem;
           word-wrap: break-word;
            word-break: break-all;
            overflow: hidden;
        }
        .edit {
          background: #0a95ff;
          text-align: center;
          border-radius: 0.06rem;
          @include sc(0.24rem, #fff);
          padding: 0.1rem 0.3rem;
        }
      }
      .q_name {
        font-size: 0.24rem;
        margin: 0.16rem 0 0.29rem;
        span {
          color: #666;
        }
        i {
          color: #e7a70c;
        }
      }
      .repeat_part {
        background: #f0f1f5;
        padding: 0.2rem;
        margin-top: 0.2rem;
        .repeat_name {
          @include sc(0.24rem, #0a95ff);
          margin-bottom: 0.1rem;
        }
        .repeat_content {
          @include sc(0.28rem, #333);
        }
      }
    }
  }
}
.check_status {
  display: flex;
  font-size: 0;
  align-items: center;
  margin-top: 0.2rem;
  justify-content: space-between;
  
  .status {
    border: 0.025rem solid #999;
    border-radius: 0.06rem;
    @include sc(0.24rem, #999);
    text-align: center;
    padding: 0.07rem 0.15rem;
    margin-right: 0.2rem;
  }
  .status.red {
    color: #fb605a;
    border-color: #fb605a;
  }
  .status.grey {
    color: #999;
    border-color: #999;
  }
  .status.green {
    color: #51b64c;
    border-color: #51b64c;
  }
  .time {
    @include sc(0.24rem, #999);
  }
}
.no_data {
  .text {
    @include sc(0.28rem, #333);
    margin: 0.4rem 0 0.3rem;
  }
  img {
    width: 4.81rem;
  }
  .ask_btn_no {
    @include sc(0.28rem, #fff);
    @include wh(2rem, 0.64rem);
    line-height: 0.64rem;
    border-radius: 0.06rem;
    background: #0a95ff;
    margin: 0 auto;
  }
}
.img_part {
  padding-bottom: 0.8rem;
  text-align: center;
}
.no_data {
  background: #f0f1f5;
  .choice_part {
    background: #fff;
    padding: 0.4rem 0.3rem 0;
    .title {
      @include sc(0.32rem, #333);
      font-weight: bold;
    }
  }
}
.ask_title{
  position: absolute;
  right: .3rem;
  top:.2rem;
  @include sc(.32rem,#0096dc)
}
</style>